<!-- Invite Member Modal -->
<div
  *ngIf="isOpen()"
  class="modal fade show d-block"
  tabindex="-1"
  role="dialog"
  (click)="onBackdropClick($event)"
  (keydown)="onKeydown($event)"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="bi bi-person-plus-fill me-2"></i>
          Invite Team Member
        </h5>
        <button
          type="button"
          class="btn-close"
          [disabled]="isProcessing()"
          (click)="close()"
          aria-label="Close"
        ></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- API Error Alert -->
        <div *ngIf="apiError()" class="alert alert-danger alert-dismissible fade show" role="alert">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          {{ apiError() }}
          <button
            type="button"
            class="btn-close"
            (click)="apiError.set(null)"
            aria-label="Close"
          ></button>
        </div>

        <form (ngSubmit)="onSubmit()">
          <!-- Email Field -->
          <div class="mb-3">
            <label for="inviteEmail" class="form-label">
              Email Address <span class="text-danger">*</span>
            </label>
            <input
              type="email"
              class="form-control"
              [class.is-invalid]="emailError()"
              id="inviteEmail"
              [(ngModel)]="email"
              name="email"
              placeholder="pilot@example.com"
              [disabled]="isProcessing()"
              required
            />
            <div *ngIf="emailError()" class="invalid-feedback">
              {{ emailError() }}
            </div>
          </div>

          <!-- First Name Field -->
          <div class="mb-3">
            <label for="inviteFirstName" class="form-label">First Name</label>
            <input
              type="text"
              class="form-control"
              id="inviteFirstName"
              [(ngModel)]="firstName"
              name="firstName"
              placeholder="John"
              [disabled]="isProcessing()"
            />
          </div>

          <!-- Last Name Field -->
          <div class="mb-3">
            <label for="inviteLastName" class="form-label">Last Name</label>
            <input
              type="text"
              class="form-control"
              id="inviteLastName"
              [(ngModel)]="lastName"
              name="lastName"
              placeholder="Doe"
              [disabled]="isProcessing()"
            />
          </div>

          <!-- Role Selection -->
          <div class="mb-3">
            <label class="form-label">
              Role(s) <span class="text-danger">*</span>
            </label>
            <div class="form-text mb-2">
              Select one or both roles for this team member
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                [class.is-invalid]="roleError()"
                type="checkbox"
                id="rolePilot"
                [(ngModel)]="isPilot"
                name="isPilot"
                [disabled]="isProcessing()"
              />
              <label class="form-check-label" for="rolePilot">
                <strong class="me-1">Pilot</strong>
                <span class="text-muted">Can log flights and view operations</span>
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                [class.is-invalid]="roleError()"
                type="checkbox"
                id="rolePilotInCharge"
                [(ngModel)]="isPilotInCharge"
                name="isPilotInCharge"
                [disabled]="isProcessing()"
              />
              <label class="form-check-label" for="rolePilotInCharge">
                <strong class="me-1">Pilot in Command (PIC)</strong>
                <span class="text-muted">Can supervise flights and generate FAA reports</span>
              </label>
            </div>

            <div *ngIf="roleError()" class="invalid-feedback d-block">
              {{ roleError() }}
            </div>
          </div>

          <!-- Info Notice -->
          <div class="alert alert-info mb-0">
            <i class="bi bi-info-circle-fill me-2"></i>
            An invitation email will be sent to <strong>{{ email() || 'the specified email' }}</strong>.
            The invitation will expire in 7 days.
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="isProcessing()"
          (click)="close()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="isProcessing()"
          (click)="onSubmit()"
        >
          <span *ngIf="isProcessing()" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <i *ngIf="!isProcessing()" class="bi bi-send-fill me-2"></i>
          {{ isProcessing() ? 'Sending...' : 'Send Invitation' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div
  *ngIf="isOpen()"
  class="modal-backdrop fade show"
></div>
